import { i18nProvider } from '../apps/xgac/xgacI18nProvider';

export const notifyCustomerAccessRequest = async (): Promise<void> => {

  if (!('Notification' in window)) return;

  let permission = Notification.permission;

  if (permission === 'default') {

    permission = await Notification.requestPermission();

  }
  if (permission !== 'granted') return;

  const title = i18nProvider.translate('notifications.customer_access_request_browser.title');
  const body = i18nProvider.translate('notifications.customer_access_request_browser.body_fallback');
  // eslint-disable-next-line no-new
  new Notification(title, { body });

};
